function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M7.63 3.57c.18-.098.37.053.37.257v13.556c0 .223-.152.412-.35.516a1.394 1.394 0 00-.02.011l-2.35 1.34c-1.64.94-2.99.16-2.99-1.74V7.78c0-.63.45-1.41 1.01-1.73l4.33-2.48zm7.092 2.532A.5.5 0 0115 6.55v13.154a.5.5 0 01-.717.45l-4.25-2.047a.5.5 0 01-.283-.451V4.446a.5.5 0 01.722-.448l4.25 2.104zM22 6.49v9.73c0 .63-.45 1.41-1.01 1.73l-3.491 2.001a.5.5 0 01-.749-.434V6.33a.5.5 0 01.252-.434L19.01 4.75C20.65 3.81 22 4.59 22 6.49z"
})));